import { useEffect, useState } from 'react';

/**
 * Значение, отстающее от исходного на заданную паузу.
 *
 * Нужно поиску по таблице: без паузы каждая нажатая буква уходит запросом на
 * сервер, и ответы возвращаются вперемешку — на «атом» может прийти ответ на
 * «ат», просто потому что он посчитался быстрее.
 */
export function useDebounced<T>(value: T, delay = 300): T {
  const [delayed, setDelayed] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setDelayed(value);
    }, delay);

    return () => {
      window.clearTimeout(timer);
    };
  }, [value, delay]);

  return delayed;
}
